if (typeof global !== "undefined" && global.__pretenderNodePolyfill) {
  delete global.self
  delete global.__pretenderNodePolyfill
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@miragejs/pretender-node-polyfill/after.js
// module id = 2299
// module chunks = 1609